export default __webpack_public_path__ + "static/media/Icon1.9a9a4e61.svg";